import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';

interface ConfirmDeleteDialogProps {
  open: boolean;
  /** Title of the entry queued for removal, shown in the prompt. */
  title: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  open,
  title,
  onCancel,
  onConfirm
}) => (
  <Dialog open={open} onClose={onCancel}>
    <DialogTitle>Remove entry?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        &quot;{title}&quot; will be removed from the list. It is only deleted once you save.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Cancel</Button>
      <Button color='error' variant='contained' onClick={onConfirm}>
        Remove
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDeleteDialog;
